/* Registers the PWA service worker outside React lifecycle.
   Only runs in production builds (CRA disables SW in dev to avoid stale caches). */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Avoid registering in CRA dev (hot reload can fight with SW caches).
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info("[PWA] service worker registered:", reg.scope);
      })
      .catch((err) => {
        console.warn("[PWA] SW registration failed", err);
      });
  });
}
